import { campaignsRoutes, campaignsNavigationItems } from "./router";
export class CampaignsModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[CampaignsModule] Registered");
        return {
            id: "campaigns",
            name: "Campaigns Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return campaignsRoutes;
    }
    getNavigationItems() {
        return campaignsNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[CampaignsModule] Unregistered");
        this.contracts = null;
    }
}
export default new CampaignsModule();
